import React, {useCallback, useEffect, useMemo, useState} from 'react'
import GENERATOR from "../generator/Generator";
import EndRecordingModal from "./EndRecordingModal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {PageManager} from "../../scripts/page-manager";
import {mygaSession} from "../../scripts/myga-session";

const RecordButton = props => {
  const {recording} = props;
  let [showModal, setShowModal] = useState(false)

  const handleRecordingEnd = useCallback(async () => {
    await GENERATOR.setTestModeEnabled(false)
    setShowModal(false)
  },[])

  const handleRecordBtnClick = useCallback(async () => {
    if (!recording) {
      await GENERATOR.resetTestSessionData()
      await GENERATOR.setTestModeEnabled(true)
      props.updatePage(PageManager.getFirstPageOfTest(),PageManager.getCurrentPage());
      await mygaSession.clearMygaSession()
    }

    // Prompt if user wants to end recording if the list has anything
    else if (GENERATOR.getTestActionList().length>1) {
      setShowModal(true)
    }
    
    else {
      await GENERATOR.setTestModeEnabled(false)
    }

  }, [props, recording])

  const btnStyle = useMemo(() => {
    let styles = {}
    if (recording) {
      styles.color = 'red'
    }
    return styles
  }, [recording])

  return (
    <>
      <button id={'TEST_record_btn'}
              className={'toolbar-btn toolbar-record-btn'}
              onClick={handleRecordBtnClick}
              style={btnStyle}>
        <FontAwesomeIcon icon={'circle'} />
      </button>
      <EndRecordingModal show={showModal}
                         onHide={() => setShowModal(false)}
                         handleYes={handleRecordingEnd}/>
    </>
  )
}

export default RecordButton